<div class="relative">
  <div *ngIf="(updateCopayDeductibleOverridesState$ | async)?.isLoading">
    <div class="z-1 w-full h-full bg-white opacity-90 absolute"></div>
    <div class="z-2 w-full h-full absolute flex align-items-center justify-content-center">
      <div class="opacity-100">
        <app-glyph-spinner></app-glyph-spinner>
      </div>
    </div>
  </div>

  <div *ngIf="!(hideSummaryStepBillingInfo$ | async)?.value && (copay$ | async)?.excludeCopay !== true">
    <h3 class="mt-0 mb-5">Order Summary</h3>
    <div class="flex align-items-center justify-content-between mb-1">
      <p class="p2 font-semibold flex-grow-0 my-0">Estimated Insurance Copayment</p>
      <p class="p2 font-semibold my-0 text-black-400" data-cy="estimated-insurance-copayment">
        {{ (copay$ | async)?.estimatedInsuranceCopayment | formatCurrency }}
      </p>
    </div>
    <button
      *ngIf="(copay$ | async)?.copayDetails"
      pButton
      type="button"
      label="View Details"
      class="p-button-text p-button-sm mb-3"
      (click)="showCopayDetails()"
      data-cy="view-copay-details-button"
      appClickEvent
      eventName="order_wizard_view_copay_details"
    ></button>
    <div class="flex align-items-center justify-content-between mb-3">
      <p class="p2 font-semibold my-0 mr-5">Outstanding Balance</p>
      <p class="p2 font-semibold my-0 text-black-400" data-cy="outstanding-balance">
        {{ (copay$ | async)?.outstandingBalance | formatCurrency }}
      </p>
    </div>
    <p-divider></p-divider>
    <div class="flex align-items-center justify-content-between">
      <p class="p2 font-semibold my-0 mr-5">Estimated Patient Responsibility</p>
      <h1 class="my-0 final-dollar-amount font-semibold" data-cy="estimated-patient-responsibility">
        {{ (copay$ | async)?.estimatedPatientResponsibility | formatCurrency }}
      </h1>
    </div>
    <div *ngIf="hasAppliedDeductibleOverrides$ | async" class="flex align-items-center justify-content-end">
      <p class="p4 font-semibold mt-2 mb-0">Updated with deductible</p>
    </div>
  </div>
  <div
    *ngIf="(skipCollectionForReconsent$ | async) && getCollectionStatusInfo(collectionStatus$ | async)"
    class="order-summary-info bg-info-100 text-primary-blue-500 p-3"
  >
    <p class="m-0 p4 font-semibold" data-cy="collection-status-info">
      {{ getCollectionStatusInfo(collectionStatus$ | async) }}
    </p>
  </div>
  <div *ngIf="(copay$ | async)?.excludeCopay">
    <div *ngIf="!(hideSummaryStepBillingInfo$ | async)?.value && (copay$ | async)?.estimatedPatientResponsibility">
      <h3 class="mt-0 mb-5">Order Summary</h3>
      <div class="flex align-items-center justify-content-between mb-4">
        <p class="p2 font-semibold my-0 mr-5">Outstanding Balance</p>
        <h1 class="my-0 final-dollar-amount font-semibold" data-cy="outstanding-balance">
          {{ (copay$ | async)?.estimatedPatientResponsibility | formatCurrency }}
        </h1>
      </div>
    </div>
    <div *ngIf="getCopayExclusionInfo(copay$ | async)" class="order-summary-info bg-info-100 text-primary-blue-500 p-3">
      <p class="m-0 p4 font-semibold" data-cy="exclude-copay-info">
        {{ getCopayExclusionInfo(copay$ | async) }}
      </p>
    </div>
  </div>
</div>

<p-dialog
  header="Copay Details"
  [(visible)]="displayCopayDetails"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [blockScroll]="false"
  [responsive]="true"
  [closable]="false"
  appendTo="body"
  styleClass="wide-dialog"
  data-cy="copay-details-modal"
>
  <div class="mb-6" data-cy="copay-details-container">
    <div data-cy="copay-details-content">
      <div>
        <p-accordion [multiple]="true" (onOpen)="onTabOpen($event)" (onClose)="onTabClose($event)">
          <p-accordionTab *ngFor="let item of (copay$ | async)?.copayDetails?.items; let i = index">
            <ng-template pTemplate="header">
              <div class="w-full flex align-content-center justify-content-between">
                <div>
                  <h4 class="my-0">{{ item.description }}</h4>
                  <p class="p4 my-0 font-light text-black-400">Quantity: {{ item.quantity }}</p>
                </div>
                <h4 *ngIf="!copayDetailsTabs[i]" class="my-0 align-self-center">
                  {{ item.estimatedInsuranceCopayment | formatCurrency }}
                </h4>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <div
                *ngFor="let itemDetail of item.details"
                class="flex align-content-center justify-content-between mb-4"
              >
                <p class="p3 my-0 font-light">{{ itemDetail.label }}</p>
                <p class="p3 my-0 font-light">{{ itemDetail.value | formatCurrency }}</p>
              </div>
              <div class="flex align-content-center justify-content-between mb-3">
                <p class="p3 my-0 font-semibold">Estimated Amount Owed by Patient</p>
                <p class="p3 my-0 font-semibold">{{ item.estimatedInsuranceCopayment | formatCurrency }}</p>
              </div>
            </ng-template>
          </p-accordionTab>
        </p-accordion>
      </div>
      <div class="flex align-content-center justify-content-between copay-details-total bg-primary-blue-50">
        <h4 class="my-0">Total Estimated Insurance Copayment</h4>
        <p class="p3 my-0 font-semibold">
          {{ (copay$ | async)?.copayDetails?.totalEstimatedInsuranceCopayment | formatCurrency }}
        </p>
      </div>
      <div class="my-3" *ngIf="outOfPocketMetStatus">
        The Out of Pocket amount has been met and the amount you pay is limited to the remaining balance.
      </div>
    </div>
  </div>

  <app-form-footer submitLabel="Close" [noCancel]="true" [handleSubmit]="hideCopayDetails.bind(this)"></app-form-footer>
</p-dialog>
